module.exports = __webpack_public_path__ + "media/schlafmitmir.883b8fb5.ogg";